import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  //COMPONENTE

  buttons: {
    display: 'flex',
    justifyContent: 'space-around',
    gap: '5px',
    fontSize: '14px'
  },
  copyLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10,
    width: '100%',
    height: '32px',
    backgroundColor: '#666666',
    borderRadius: '10px',
    border: '1px solid #666666',
    borderColor: '#666666'
  },
  pdfLink: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none'
  },
  pdfText: {
    color: 'white',
    textDecoration: 'none',
    margin: 0,
    marginLeft: 10
  },

  // DOC

  doc: {
    fontFamily: 'Open Sans'
  },
  mapPage: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20
  },
  header: {
    paddingTop: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20
  },
  gencatLogo: {
    width: 100
  },
  hipermapaText: {
    width: 200,
    fontSize: 12,
    fontWeight: 'bold',
    position: 'absolute',
    left: '52%',
    top: 20,
    transform: 'translate(-50%, 0)'
  },
  hipermapaTextSmall: {
    width: 100,
    fontSize: 8,
    fontWeight: 'bold',
    position: 'absolute',
    left: '55%',
    transform: 'translate(-50%, 0)'
  },
  dataText: {
    fontSize: 7
  },
  mapContainer: {
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: 'white',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  mapImg: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: 'black'
  },
  mapFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  llegendaPage: {
    padding: 20,
    paddingTop: 0,
    fontSize: 10
  },
  llegendaTitle: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: 20,
    textDecoration: 'underline'
  },
  layerView: {
    marginLeft: 20,
    fontSize: 8,
    borderBottomStyle: 'solid',
    borderBottomColor: '#E9E9E9',
    borderBottomWidth: 1,
    marginBottom: 10
  },
  layerDisplay: {
    flexDirection: 'row',
    marginLeft: 20,
    marginBottom: 10,
    alignItems: 'center'
  },
  layerDisplaySt: {
    marginBottom: 10
  },
  layerDisplayStTit: {
    marginLeft: 20,
    marginBottom: 5
  },
  layerDisplayStReps: {
    marginLeft: 40,
    marginBottom: 10
  },
  svgMargin: {
    marginRight: 5
    // backgroundColor: 'black'
    // borderStyle: 'solid',
    // borderColor: 'black',
    // borderWidth: '1'
  },
  abstract: {
    fontSize: 6,
    color: 'black',
    marginLeft: 60,
    marginBottom: 15,
    fontWeight: 'bold'
  }
});
